var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRating = function SvgRating(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F90",
    stroke: "#F90",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.522 2.302c.153-.311.23-.467.335-.516a.33.33 0 0 1 .287 0c.104.05.18.205.334.516l1.458 2.954c.045.091.068.137.101.173q.045.048.104.075a.7.7 0 0 0 .196.043l3.261.477c.343.05.515.075.595.159.069.073.101.173.088.273-.015.114-.14.236-.388.478L11.534 9.23c-.073.072-.11.107-.134.15a.3.3 0 0 0-.04.122c-.005.049.004.1.02.2l.557 3.245c.059.342.088.513.033.615a.33.33 0 0 1-.232.169c-.114.02-.267-.06-.575-.222l-2.915-1.533a.7.7 0 0 0-.184-.08.3.3 0 0 0-.128 0 .7.7 0 0 0-.184.08L4.837 13.51c-.308.162-.461.243-.575.222a.33.33 0 0 1-.232-.169c-.055-.102-.026-.273.033-.615l.556-3.245a.7.7 0 0 0 .02-.2.3.3 0 0 0-.04-.122.7.7 0 0 0-.133-.15L2.107 6.934c-.249-.242-.373-.364-.388-.478-.013-.1.02-.2.089-.273.079-.084.25-.109.594-.16l3.26-.476c.102-.015.153-.022.197-.042a.3.3 0 0 0 .104-.076c.033-.036.056-.082.101-.173z"
  })));
};
export default SvgRating;